import { createValidation } from '../../utils/validation';
import applicationSettingConfig from './applicationSettingConfig';

// Create validation factory for ApplicationSetting entity
const createApplicationSettingValidation = () => {
  return createValidation(applicationSettingConfig.fields);
};

// Export both the factory and a default instance
export const validateApplicationSettingData = createApplicationSettingValidation();
export const createApplicationSettingValidationSchema = createApplicationSettingValidation;
export default createApplicationSettingValidation;

